// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SortAscIcon = (props: any) => {
  return (
    <svg
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 4.5L4 1.5L7 4.5"
        stroke="#9B9B9B"
        strokeWidth="1.5"
        strokeLinecap="round"
        fillOpacity="0"
      />
    </svg>
  )
}
